import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const FormLabel = ({ className, children, ...props }) => {
  return (
    <label
      className={cx('uppercase text-white text-sm tracking-wider block mb-2', className)}
      {...props}
    >
      {children}
    </label>
  );
};

FormLabel.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

FormLabel.defaultProps = {
  children: null,
  className: '',
};

export default FormLabel;
